document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('.swiper-wrapper').forEach(wrapper => {
    const container = wrapper.querySelector('.acf-innerblocks-container');
    if (container) {
      while (container.firstChild) {
        wrapper.appendChild(container.firstChild);
      }
      container.remove();
    }
  });

  const sliders = document.querySelectorAll(".carousel-custom-block");

  sliders.forEach((slider) => {
    const optionsAttr = slider.getAttribute('data-swiper-options');
    let options = optionsAttr ? JSON.parse(optionsAttr) : {};

    const isMobile = window.matchMedia('(max-width: 767px)').matches;

    if (options.sameHeight) {
      slider.classList.add('has-same-height-slides');
    }

    const config = {
      loop: true,
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: options.slidesPerView,
        },
      },
    };

    // En móvil: forzar navegación y ocultar paginación
    // En desktop: respetar la configuración ACF
    if (isMobile) {
      config.navigation = {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev'),
      };
    } else {
      if (options.pagination) {
        config.pagination = {
          el: slider.querySelector('.swiper-pagination'),
          clickable: true,
        };
      }

      if (options.navigation) {
        config.navigation = {
          nextEl: slider.querySelector('.swiper-button-next'),
          prevEl: slider.querySelector('.swiper-button-prev'),
        };
      }
    }

    new Swiper(
        slider,
        {
            ...config,
            on: {
                init: function (swiper) {}
            }
        }
    );
  });
  
});
